import { CurrencyHelper } from '@getaccept/lib-shared/src/helpers/currency.helper';
import type {
  PricingTableCurrencyDisplay,
  PricingTable,
  PricingTableCurrency,
  PricingTableCurrencySettings,
} from '../../types';
import { CustomCurrency, EPricingTableCurrencyDisplay } from '../../types/enums';
import { PricingTableHelper } from '../pricing-table.helper';

export const getCurrency = (localState: Partial<PricingTable>): PricingTableCurrency => {
  const currencies = CurrencyHelper.getCurrencies();
  const currencySettings = getLocalStateCurrencySettings(localState);
  const { locale: selectedLocale, formatOptions } = currencySettings;
  const { currency: selectedCurrency } = formatOptions;
  return {
    ...currencies.find(
      currency => currency.currencyCode === selectedCurrency && currency.locale === selectedLocale
    ),
    key: `${selectedLocale}${selectedCurrency}`,
  };
};

export const getCurrencyDisplays = (
  localState: Partial<PricingTable>,
  sampleValue: string
): PricingTableCurrencyDisplay[] => {
  const currency = getCurrency(localState);
  const newCurrencySettings: PricingTableCurrencySettings = {
    locale: currency?.locale,
    formatOptions: {
      currency: currency?.currencyCode,
    },
  };

  const currencies = [
    {
      label: PricingTableHelper.currencyFormat(sampleValue, {
        ...newCurrencySettings,
        formatOptions: {
          ...newCurrencySettings.formatOptions,
          currencyDisplay: EPricingTableCurrencyDisplay.Code,
        },
      }),
      key: EPricingTableCurrencyDisplay.Code,
    },
  ];
  if (currency?.currencyCode !== CustomCurrency.Ore) {
    currencies.unshift({
      label: PricingTableHelper.currencyFormat(sampleValue, {
        ...newCurrencySettings,
        formatOptions: {
          ...newCurrencySettings.formatOptions,
          currencyDisplay: EPricingTableCurrencyDisplay.Symbol,
        },
      }),
      key: EPricingTableCurrencyDisplay.Symbol,
    });
  }
  return currencies;
};

export const getLocalStateCurrencySettings = (
  localState: Partial<PricingTable>
): PricingTableCurrencySettings => localState?.currencySettings;

export const getLocalStateCurrencySettingsCurrencyDisplay = (
  localState: Partial<PricingTable>
): string => getLocalStateCurrencySettings(localState)?.formatOptions?.currencyDisplay;
